import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/billiards-4-1920w.webp")